import * as React from "react";
import styled from "styled-components";
import Theme from "../Theme";
import { Paper } from "@material-ui/core";
import SocialRow from "./SocialRow";

const Footer = styled(Paper)`
  width: 100%;
  height: 135px;
  background-color: ${Theme.colors.darkBackground};
  color: ${Theme.colors.greyText};
  border-top: 1px solid ${Theme.colors.accentCool};
  display: flex;
  margin-top: 2em;
  text-align: center;
`;

const LogoContainer = styled.div`
  /* margin: auto 0 auto 2em; */
  margin: auto;
`;

const Copyright = styled.div`
  padding-top: 1em;
  font-size: 13px;
  line-height: 0.35em;
`;

const CopyrightMain = styled.p`
  line-height: 0.55em;
`;

const CopyrightInfo = styled.p``;

export default () => {
  return (
    <Footer component="footer" square>
      <LogoContainer>
        <Copyright>
          <CopyrightMain>&copy; Skyward, Inc. {new Date().getFullYear()}</CopyrightMain>
          <CopyrightInfo>All rights reserved</CopyrightInfo>
          <CopyrightInfo>Developed &amp; supported in the USA</CopyrightInfo>
        </Copyright>

        <p>
          <SocialRow />
        </p>
      </LogoContainer>
    </Footer>
  );
};
